var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ExportMenu } from '@web/components/layout/ExportMenu/ExportMenu';
import Table from '@web/components/layout/Table/Table';
import { WidgetTitle } from '@web/components/layout/WidgetTitle/WidgetTitle';
import UserAvatar from '@web/components/UserAvatar';
import { isAiButtonDisabled, isInsightsDataEmpty } from '@web/utility';
import { InsightTypeEnum } from '@workalizer/shared';
import { useTranslation } from 'react-i18next';
export var SummaryTable = function (_a) {
    var usersSummary = _a.usersSummary, refetch = _a.refetch;
    var t = useTranslation().t;
    var summaryCellClass = '!text-left !px-4';
    var columns = [
        {
            title: t('meetItemDetails.summary.participants'),
            isVisible: true,
            orderByField: 'user',
            className: '!text-left'
        },
        {
            title: t('meetItemDetails.summary.duration'),
            isVisible: true,
            orderByField: 'duration',
            className: '!text-left'
        },
        {
            title: t('meetItemDetails.summary.presentation'),
            isVisible: true,
            orderByField: 'presentationCount',
            className: '!text-left'
        }
    ];
    var rows = usersSummary.map(function (summary) { return [
        {
            id: summary.user.email,
            className: summaryCellClass,
            render: function () { return (_jsxs("div", __assign({ className: "flex items-center" }, { children: [_jsx(UserAvatar, { user: summary.user, size: "small" }), _jsxs("div", __assign({ className: "ml-4" }, { children: [_jsx("div", __assign({ className: "text-sm font-medium text-gray-900" }, { children: summary.user.name || summary.user.email })), _jsx("div", __assign({ className: "text-sm text-gray-500" }, { children: summary.user.email }))] }))] }))); }
        },
        {
            id: "".concat(summary.user.email, "-duration"),
            className: summaryCellClass,
            render: function () { return (_jsx("div", __assign({ className: "text-left text-sm text-gray-900" }, { children: summary.duration }))); }
        },
        {
            id: "".concat(summary.user.email, "-presentation"),
            className: summaryCellClass,
            render: function () { return (_jsx("div", __assign({ className: "text-left text-sm text-gray-900" }, { children: summary.presentationCount }))); }
        }
    ]; });
    return (_jsxs("div", { children: [_jsx(WidgetTitle, { title: t('meetItemDetails.summary.title'), description: "widgetTitleDescriptions.itemDetails.meetSummaryTable", insightType: InsightTypeEnum.meetSummaryTable, insightsData: usersSummary, refetch: refetch, csvExport: _jsx(ExportMenu, { fileName: t('meetItemDetails.summary.title'), onExportHandler: function () { return __awaiter(void 0, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, usersSummary.map(function (summary) {
                                    var _a;
                                    return (_a = {},
                                        _a[t('meetItemDetails.summary.participants')] = summary.user.name || summary.user.email,
                                        _a[t('meetItemDetails.summary.duration')] = summary.duration,
                                        _a[t('meetItemDetails.summary.presentation')] = summary.presentationCount,
                                        _a);
                                })];
                        });
                    }); }, disabled: isAiButtonDisabled(usersSummary) }) }), _jsx("div", __assign({ className: "relative" }, { children: _jsx(Table, { columns: columns, data: isInsightsDataEmpty(usersSummary) ? [] : rows }) }))] }));
};
